import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatSort, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store',
  templateUrl: './store.component.html',
  styleUrls: ['./store.component.css']
})
export class StoreComponent implements OnInit {
  model = {
    'table_name': 'store', 'store_id': '0', 'store_name': '', 'store_name_en': '', 'branch_id': '0',
    'rep_id': '0', 'comment': ''
  };

  branchList = [];
  repEmpList = [];

  Success_Msg; Error_Msg; Branch_Msg; Store_Name_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, private dialogRef: MatDialogRef<StoreComponent>,
    @Inject(MAT_DIALOG_DATA) public dialog_data: any, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Store_Name_Msg').subscribe((res: string) => {
      this.Store_Name_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });
  }


  ngOnInit() {

    if (this.dialog_data != null)
      this.model = this.dialog_data;

    let query;
    let obj;

    query = this.queryList.all_branch;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
      });

    query = this.queryList.all_repEmp;
    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.repEmpList = data.data['list'];
      });
  }

  add() {

    if (this.model['branch_id'] != '' && this.model['store_name'] != '') {
      let values = [];
      values.push(this.model);

      let obj;
      if (this.model['store_id'] == '0')
        obj = { cmd: 'add', values: values };
      else {
        let where = [{ 'store_id': this.model['store_id'] }];
        obj = { cmd: 'update', values: values, where: where };
      }
      this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
        .subscribe(data => {
          this.applicationConstants.appComp.hideBusyCursor();
          if (data.status['type'] == 'success') {
            alert(this.Success_Msg);
            this.dialog_data = { 'op_type': 'success' };
            this.dialogRef.close(this.dialog_data);
          }
          else {
            alert(this.Error_Msg);
          }
        });
    }
    else if (this.model['store_name'] == '') {
      alert(this.Store_Name_Msg);
    }
    else if (this.model['branch_id'] == '') {
      alert(this.Branch_Msg);
    }
  }

  cancel() {
    this.dialog_data = { 'op_type': 'cancel' };
    this.dialogRef.close(this.dialog_data);
  }

}

